import React, {Component} from 'react';
import { Container } from 'reactstrap';
import profilepic5 from './assets/profile-pic05.png';
import Linkedin1 from './assets/Linkedin01.png';
import Facebook1 from './assets/facebook01.png';
import Github1 from './assets/GitHub01.png';
import Image from 'react-bootstrap/Image';
import './Home.css';
import AboutMe from "./AboutMe";
import {Navbar, Nav} from 'react-bootstrap';
import { Link, Element } from "react-scroll";
import Experience from './Experience';
import Education from './Education';
import RelevantCourses from './RelevantCourses';
import Skills from './Skills';
import Projects from './Projects';
import Contact from './Contact';
import Blog from './Blog';


class Home extends Component {

    constructor(props){
        super(props)
        this.state = {
        //   field: value
        }
        //creates a reference for your element to use
        this.myDivToFocus = React.createRef()
     }
   
     handleOnClick = (event) => {
        //.current is verification that your element has rendered
        if(this.myDivToFocus.current){
            this.myDivToFocus.current.scrollIntoView({ 
               behavior: "smooth", 
               block: "nearest"
            })
        }
    }

    render() { 
        return (
                <div>
                    <div className="divStyle">
                    
                    <div className="divAppNav">
                    <Navbar sticky="top" position="sticky"
                       collapseOnSelect expand="lg" variant="dark">
                        <Navbar.Brand>
                            <Link
                                to="home"
                                spy={true}
                                smooth={true}
                                duration={500}>
                                Ankit Lalwani</Link>
                        </Navbar.Brand>
                        <span className="navStatusPill">Available for backend/cloud roles</span>
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                        <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="mr-auto">
                            <Nav.Link><Link
                                to="about"
                                spy={true}
                                smooth={true}
                                duration={500}
                                >About</Link></Nav.Link>
                            <Nav.Link><Link
                                to="experience"
                                spy={true}
                                smooth={true}
                                duration={500}>                                
                                Experience</Link></Nav.Link>
                            <Nav.Link>
                            <Link
                                to="projects"
                                spy={true}
                                smooth={true}
                                duration={500}>Projects</Link></Nav.Link>
                            <Nav.Link>
                            <Link
                                to="skills"
                                spy={true}
                                smooth={true}
                                duration={500}>
                                Skills</Link></Nav.Link>
                            <Nav.Link>
                            <Link
                                to="blog"
                                spy={true}
                                smooth={true}
                                duration={500}>
                                Blog</Link></Nav.Link>
                            <Nav.Link>
                            <Link
                                to="relevantCourses"
                                spy={true}
                                smooth={true}
                                duration={500}>
                                Courses</Link></Nav.Link>
                        </Nav>
                        <Nav>
                            <Nav.Link className="navContactCta">
                            <Link
                                to="contact"
                                spy={true}
                                smooth={true}
                                duration={500}>
                                Contact</Link></Nav.Link>
                        </Nav>
                        </Navbar.Collapse>
                    </Navbar>
                    </div>
                    <Element name="home" className="element"></Element>
                    <Container>
                    <div className="divProfileImage">
                        <Image src={profilepic5} roundedCircle fluid alt="Ankit Lalwani profile portrait"></Image>
                        <p className="heroEyebrow">Software Engineer</p>
                        <h1 className="h1Name">Ankit Lalwani</h1>
                        <h2 className="h1Role">
                            <span className="heroTaglineText">Senior Backend Engineer | Cloud-Native Developer | AI-Enabled Systems Builder</span>
                        </h2>
                        <p className="heroIntro">
                            I build event-driven backend platforms where Java, cloud infrastructure, IoT events, and AI-assisted workflows turn operational complexity into reliable systems.
                        </p>
                        <div className="heroStats" aria-label="Professional highlights">
                            <div>
                                <strong>14+</strong>
                                <span>Years Engineering</span>
                            </div>
                            <div>
                                <strong>Java</strong>
                                <span>Backend Systems</span>
                            </div>
                            <div>
                                <strong>AWS</strong>
                                <span>Cloud-Native</span>
                            </div>
                            <div>
                                <strong>AI + IoT</strong>
                                <span>Automation Focus</span>
                            </div>
                        </div>
                        <div className="heroActions">
                        <a className="heroButton heroButtonPrimary" href="AnkitLalwani_Resume_0626.pdf" target = "_blank" rel="noopener noreferrer">
                            View Resume</a>
                        <Link
                            className="heroButton heroButtonSecondary"
                            to="projects"
                            spy={true}
                            smooth={true}
                            duration={500}>
                            See Projects</Link>
                        <Link
                            className="heroButton heroButtonSecondary"
                            to="blog"
                            spy={true}
                            smooth={true}
                            duration={500}>
                            Read Blog</Link>
                        </div>
                        <div className="heroSocial">
                        <a className="divOtherHREF" href="https://www.linkedin.com/in/ankit-lalwani/" target = "_blank" rel="noopener noreferrer" aria-label="LinkedIn profile">
                            <img className="divOtherImage" src={Linkedin1} alt="LinkedIn"></img></a>
                        <a className="divOtherHREF" href="https://www.facebook.com/ankit.lalwani.58" target = "_blank" rel="noopener noreferrer" aria-label="Facebook profile">
                            <img className="divOtherImage" src={Facebook1} alt="Facebook"></img></a>
                        <a className="divOtherHREF" href="https://github.com/ankitlalwani" target = "_blank" rel="noopener noreferrer" aria-label="GitHub profile">
                            <img className="divOtherImage" src={Github1} alt="GitHub"></img></a>
                        </div>
                    </div>
                    </Container>
                    
                    <div className="div-section-top"><Element name="about" className="element"></Element>
                        <div>

                        </div>
                        <div>
                       <AboutMe />
                       </div>
                    </div>
                    
                    <div className="div-section-top"><Element name="experience" className="element"></Element>
                       <Experience />
                    </div>

                    <div className="div-section-top"><Element name="education" className="element"></Element>
                       <Education />
                    </div>

                    <div className="div-section-top"><Element name="projects" className="element"></Element>
                       <Projects />
                    </div>

                    <div className="div-section-top"><Element name="skills" className="element"></Element>
                       <Skills />
                    </div>
                    <div className="div-section-top"><Element name="blog" className="element"></Element>
                       <Blog />
                    </div>
                    <div className="div-section-top"><Element name="relevantCourses" className="element"></Element>
                       <RelevantCourses />
                    </div>
                    <div className="div-section-top"><Element name="contact" className="element"></Element>
                       <Contact />
                    </div>
                    <h5 className="h5CopyrightFooter"> Copyright © 2020 by Ankit Lalwani </h5>
                    <Link
                        className="backToTop"
                        to="home"
                        spy={true}
                        smooth={true}
                        duration={500}
                        aria-label="Back to top">
                        ↑
                    </Link>
                    </div>
            </div>
        
         );
    }
}
 
export default Home;
